import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "profile-creation-wizard__side-mobile" }
const _hoisted_2 = { slot: "bottom-sheet-content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "profile-creation-wizard__side-desktop" }
const _hoisted_6 = { class: "profile-creation-wizard__side-description" }
const _hoisted_7 = { class: "profile-creation-wizard__side-iconTitle" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = ["innerHTML"]

import {ref, onMounted} from 'vue';
    import {bool} from 'vue-types';
    import BottomSheetDisplayer from '@/common/ui/BottomSheetDisplayer';
    import {getTipsClassPosition} from '@/common/ui/GetTipsClassPosition';
    import {useTranslation} from '@malt/vue3-use';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'DailyRateSide',
  props: {
        isRegular: bool().isRequired,
    },
  setup(__props) {

const props = __props;

    

    const tipsClassPosition = getTipsClassPosition(85);
    const bottomSheetDisplayer = ref<BottomSheetDisplayer>(null);
    const priceSide = ref(null);

    const {msg} = useTranslation();

    onMounted(() => {
        bottomSheetDisplayer.value = new BottomSheetDisplayer('', '', priceSide.value, 'div.profile-creation-wizard');
    });

return (_ctx: any,_cache: any) => {
  const _component_joy_bottom_sheet = _resolveComponent("joy-bottom-sheet")!
  const _component_joy_icon = _resolveComponent("joy-icon")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "priceSide",
    ref: priceSide,
    class: "profile-creation-wizard__side"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_joy_bottom_sheet, {
        id: "details-price-bottom-sheet",
        "close-label": _unref(msg)('general.close')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h2", null, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.side.details.price.all.title')), 1),
            (__props.isRegular)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("p", null, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.side.details.price.freelancer.subtitle.one')), 1),
                  _createElementVNode("p", null, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.side.details.price.freelancer.subtitle.two')), 1)
                ]))
              : (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  innerHTML: _unref(msg)('profile.creation.completion.wizard.side.details.price.strategy.subtitle')
                }, null, 8, _hoisted_4))
          ])
        ]),
        _: 1
      }, 8, ["close-label"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "profile-creation-wizard__side-container",
        style: _normalizeStyle(_unref(tipsClassPosition))
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_joy_icon, {
              name: "money",
              size: "small"
            }),
            _createElementVNode("strong", null, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.side.details.price.all.title')), 1)
          ]),
          (__props.isRegular)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.side.details.price.freelancer.subtitle.one')) + " ", 1),
                _hoisted_9,
                _hoisted_10,
                _createTextVNode(" " + _toDisplayString(_unref(msg)('profile.creation.completion.wizard.side.details.price.freelancer.subtitle.two')), 1)
              ]))
            : (_openBlock(), _createElementBlock("p", {
                key: 1,
                innerHTML: _unref(msg)('profile.creation.completion.wizard.side.details.price.strategy.subtitle')
              }, null, 8, _hoisted_11))
        ])
      ], 4)
    ])
  ], 512))
}
}

})